/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    h3: "h3",
    p: "p",
    span: "span",
    math: "math",
    semantics: "semantics",
    mrow: "mrow",
    mi: "mi",
    mo: "mo",
    annotation: "annotation",
    a: "a",
    em: "em",
    mn: "mn",
    mfrac: "mfrac"
  }, _provideComponents(), props.components);
  return React.createElement(React.Fragment, null, React.createElement(_components.h2, null, "Day Four: Domain Specific Search and Sorting Algorithms"), "\n", React.createElement(_components.h3, null, "TL/DR"), "\n", React.createElement(_components.p, null, "In the most general case it’s impossible to beat an average time complexity of ", React.createElement(_components.span, {
    className: "math math-inline"
  }, React.createElement(_components.span, {
    className: "katex"
  }, React.createElement(_components.span, {
    className: "katex-mathml"
  }, React.createElement(_components.math, {
    xmlns: "http://www.w3.org/1998/Math/MathML"
  }, React.createElement(_components.semantics, null, React.createElement(_components.mrow, null, React.createElement(_components.mi, {
    mathvariant: "double-struck"
  }, "O"), React.createElement(_components.mo, {
    stretchy: "false"
  }, "("), React.createElement(_components.mi, null, "n"), React.createElement(_components.mi, null, "log"), React.createElement(_components.mo, null, "⁡"), React.createElement(_components.mo, {
    stretchy: "false"
  }, "("), React.createElement(_components.mi, null, "n"), React.createElement(_components.mo, {
    stretchy: "false"
  }, ")"), React.createElement(_components.mo, {
    stretchy: "false"
  }, ")")), React.createElement(_components.annotation, {
    encoding: "application/x-tex"
  }, "\\O(n\\log(n))")))), React.createElement(_components.span, {
    className: "katex-html",
    "aria-hidden": "true"
  }, React.createElement(_components.span, {
    className: "base"
  }, React.createElement(_components.span, {
    className: "strut",
    style: {
      height: "1em",
      verticalAlign: "-0.25em"
    }
  }), React.createElement(_components.span, {
    className: "mord mathbb"
  }, "O"), React.createElement(_components.span, {
    className: "mopen"
  }, "("), React.createElement(_components.span, {
    className: "mord mathnormal"
  }, "n"), React.createElement(_components.span, {
    className: "mspace",
    style: {
      marginRight: "0.1667em"
    }
  }), React.createElement(_components.span, {
    className: "mop"
  }, "lo", React.createElement(_components.span, {
    style: {
      marginRight: "0.01389em"
    }
  }, "g")), React.createElement(_components.span, {
    className: "mopen"
  }, "("), React.createElement(_components.span, {
    className: "mord mathnormal"
  }, "n"), React.createElement(_components.span, {
    className: "mclose"
  }, "))"))))), " when sorting, or\n", React.createElement(_components.span, {
    className: "math math-inline"
  }, React.createElement(_components.span, {
    className: "katex"
  }, React.createElement(_components.span, {
    className: "katex-mathml"
  }, React.createElement(_components.math, {
    xmlns: "http://www.w3.org/1998/Math/MathML"
  }, React.createElement(_components.semantics, null, React.createElement(_components.mrow, null, React.createElement(_components.mi, {
    mathvariant: "double-struck"
  }, "O"), React.createElement(_components.mo, {
    stretchy: "false"
  }, "("), React.createElement(_components.mi, null, "l"), React.createElement(_components.mi, null, "o"), React.createElement(_components.mi, null, "g"), React.createElement(_components.mo, {
    stretchy: "false"
  }, "("), React.createElement(_components.mi, null, "n"), React.createElement(_components.mo, {
    stretchy: "false"
  }, ")"), React.createElement(_components.mo, {
    stretchy: "false"
  }, ")")), React.createElement(_components.annotation, {
    encoding: "application/x-tex"
  }, "\\O(log(n))")))), React.createElement(_components.span, {
    className: "katex-html",
    "aria-hidden": "true"
  }, React.createElement(_components.span, {
    className: "base"
  }, React.createElement(_components.span, {
    className: "strut",
    style: {
      height: "1em",
      verticalAlign: "-0.25em"
    }
  }), React.createElement(_components.span, {
    className: "mord mathbb"
  }, "O"), React.createElement(_components.span, {
    className: "mopen"
  }, "("), React.createElement(_components.span, {
    className: "mord mathnormal",
    style: {
      marginRight: "0.01968em"
    }
  }, "l"), React.createElement(_components.span, {
    className: "mord mathnormal"
  }, "o"), React.createElement(_components.span, {
    className: "mord mathnormal",
    style: {
      marginRight: "0.03588em"
    }
  }, "g"), React.createElement(_components.span, {
    className: "mopen"
  }, "("), React.createElement(_components.span, {
    className: "mord mathnormal"
  }, "n"), React.createElement(_components.span, {
    className: "mclose"
  }, "))"))))), " when searching. However, for special (but common) use cases, we can do substantially better.\n", React.createElement(_components.a, {
    href: "https://en.wikipedia.org/wiki/Radix_sort"
  }, "Radix sort"), " can sort integers in ", React.createElement(_components.span, {
    className: "math math-inline"
  }, React.createElement(_components.span, {
    className: "katex"
  }, React.createElement(_components.span, {
    className: "katex-mathml"
  }, React.createElement(_components.math, {
    xmlns: "http://www.w3.org/1998/Math/MathML"
  }, React.createElement(_components.semantics, null, React.createElement(_components.mrow, null, React.createElement(_components.mi, {
    mathvariant: "double-struck"
  }, "O"), React.createElement(_components.mo, {
    stretchy: "false"
  }, "("), React.createElement(_components.mi, null, "k"), React.createElement(_components.mo, null, "⋅"), React.createElement(_components.mi, null, "n"), React.createElement(_components.mo, {
    stretchy: "false"
  }, ")")), React.createElement(_components.annotation, {
    encoding: "application/x-tex"
  }, "\\O(k\\cdot n)")))), React.createElement(_components.span, {
    className: "katex-html",
    "aria-hidden": "true"
  }, React.createElement(_components.span, {
    className: "base"
  }, React.createElement(_components.span, {
    className: "strut",
    style: {
      height: "1em",
      verticalAlign: "-0.25em"
    }
  }), React.createElement(_components.span, {
    className: "mord mathbb"
  }, "O"), React.createElement(_components.span, {
    className: "mopen"
  }, "("), React.createElement(_components.span, {
    className: "mord mathnormal",
    style: {
      marginRight: "0.03148em"
    }
  }, "k"), React.createElement(_components.span, {
    className: "mspace",
    style: {
      marginRight: "0.2222em"
    }
  }), React.createElement(_components.span, {
    className: "mbin"
  }, "⋅"), React.createElement(_components.span, {
    className: "mspace",
    style: {
      marginRight: "0.2222em"
    }
  })), React.createElement(_components.span, {
    className: "base"
  }, React.createElement(_components.span, {
    className: "strut",
    style: {
      height: "1em",
      verticalAlign: "-0.25em"
    }
  }), React.createElement(_components.span, {
    className: "mord mathnormal"
  }, "n"), React.createElement(_components.span, {
    className: "mclose"
  }, ")"))))), " time, where ", React.createElement(_components.span, {
    className: "math math-inline"
  }, React.createElement(_components.span, {
    className: "katex"
  }, React.createElement(_components.span, {
    className: "katex-mathml"
  }, React.createElement(_components.math, {
    xmlns: "http://www.w3.org/1998/Math/MathML"
  }, React.createElement(_components.semantics, null, React.createElement(_components.mrow, null, React.createElement(_components.mi, null, "k")), React.createElement(_components.annotation, {
    encoding: "application/x-tex"
  }, "k")))), React.createElement(_components.span, {
    className: "katex-html",
    "aria-hidden": "true"
  }, React.createElement(_components.span, {
    className: "base"
  }, React.createElement(_components.span, {
    className: "strut",
    style: {
      height: "0.6944em"
    }
  }), React.createElement(_components.span, {
    className: "mord mathnormal",
    style: {
      marginRight: "0.03148em"
    }
  }, "k"))))), " is the\nlength of the integer in digits. ", React.createElement(_components.a, {
    href: "https://en.wikipedia.org/wiki/Interpolation_search"
  }, "Interpolation search"), " will find a\nkey in ", React.createElement(_components.span, {
    className: "math math-inline"
  }, React.createElement(_components.span, {
    className: "katex"
  }, React.createElement(_components.span, {
    className: "katex-mathml"
  }, React.createElement(_components.math, {
    xmlns: "http://www.w3.org/1998/Math/MathML"
  }, React.createElement(_components.semantics, null, React.createElement(_components.mrow, null, React.createElement(_components.mi, {
    mathvariant: "double-struck"
  }, "O"), React.createElement(_components.mo, {
    stretchy: "false"
  }, "("), React.createElement(_components.mi, null, "log"), React.createElement(_components.mo, null, "⁡"), React.createElement(_components.mi, null, "log"), React.createElement(_components.mo, null, "⁡"), React.createElement(_components.mo, {
    stretchy: "false"
  }, "("), React.createElement(_components.mi, null, "n"), React.createElement(_components.mo, {
    stretchy: "false"
  }, ")"), React.createElement(_components.mo, {
    stretchy: "false"
  }, ")")), React.createElement(_components.annotation, {
    encoding: "application/x-tex"
  }, "\\O(\\log\\log(n))")))), React.createElement(_components.span, {
    className: "katex-html",
    "aria-hidden": "true"
  }, React.createElement(_components.span, {
    className: "base"
  }, React.createElement(_components.span, {
    className: "strut",
    style: {
      height: "1em",
      verticalAlign: "-0.25em"
    }
  }), React.createElement(_components.span, {
    className: "mord mathbb"
  }, "O"), React.createElement(_components.span, {
    className: "mopen"
  }, "("), React.createElement(_components.span, {
    className: "mop"
  }, "lo", React.createElement(_components.span, {
    style: {
      marginRight: "0.01389em"
    }
  }, "g")), React.createElement(_components.span, {
    className: "mspace",
    style: {
      marginRight: "0.1667em"
    }
  }), React.createElement(_components.span, {
    className: "mop"
  }, "lo", React.createElement(_components.span, {
    style: {
      marginRight: "0.01389em"
    }
  }, "g")), React.createElement(_components.span, {
    className: "mopen"
  }, "("), React.createElement(_components.span, {
    className: "mord mathnormal"
  }, "n"), React.createElement(_components.span, {
    className: "mclose"
  }, "))"))))), " on average, assuming that the search data is uniformly distributed."), "\n", React.createElement(_components.h2, null, "Radix Sort"), "\n", React.createElement(_components.p, null, "CS 101 usually covers the optimality of binary search, and by extension the log linear lower bound on sorting a list.\nHowever, this bound only applies to comparison sorts, and there are many ways to sort without direct comparison. Doing\nso isn’t “cheating” from an information theoretic standpoint, just as the fact that the ", React.createElement(_components.em, null, "average"), " ", React.createElement(_components.span, {
    className: "math math-inline"
  }, React.createElement(_components.span, {
    className: "katex"
  }, React.createElement(_components.span, {
    className: "katex-mathml"
  }, React.createElement(_components.math, {
    xmlns: "http://www.w3.org/1998/Math/MathML"
  }, React.createElement(_components.semantics, null, React.createElement(_components.mrow, null, React.createElement(_components.mi, {
    mathvariant: "double-struck"
  }, "O"), React.createElement(_components.mo, {
    stretchy: "false"
  }, "("), React.createElement(_components.mn, null, "1"), React.createElement(_components.mo, {
    stretchy: "false"
  }, ")")), React.createElement(_components.annotation, {
    encoding: "application/x-tex"
  }, "\\O(1)")))), React.createElement(_components.span, {
    className: "katex-html",
    "aria-hidden": "true"
  }, React.createElement(_components.span, {
    className: "base"
  }, React.createElement(_components.span, {
    className: "strut",
    style: {
      height: "1em",
      verticalAlign: "-0.25em"
    }
  }), React.createElement(_components.span, {
    className: "mord mathbb"
  }, "O"), React.createElement(_components.span, {
    className: "mopen"
  }, "("), React.createElement(_components.span, {
    className: "mord"
  }, "1"), React.createElement(_components.span, {
    className: "mclose"
  }, ")"))))), " look-up time\nfor a hash map isn’t at odds with the ", React.createElement(_components.span, {
    className: "math math-inline"
  }, React.createElement(_components.span, {
    className: "katex"
  }, React.createElement(_components.span, {
    className: "katex-mathml"
  }, React.createElement(_components.math, {
    xmlns: "http://www.w3.org/1998/Math/MathML"
  }, React.createElement(_components.semantics, null, React.createElement(_components.mrow, null, React.createElement(_components.mi, {
    mathvariant: "double-struck"
  }, "O"), React.createElement(_components.mo, {
    stretchy: "false"
  }, "("), React.createElement(_components.mi, null, "log"), React.createElement(_components.mo, null, "⁡"), React.createElement(_components.mo, {
    stretchy: "false"
  }, "("), React.createElement(_components.mi, null, "n"), React.createElement(_components.mo, {
    stretchy: "false"
  }, ")"), React.createElement(_components.mo, {
    stretchy: "false"
  }, ")")), React.createElement(_components.annotation, {
    encoding: "application/x-tex"
  }, "\\O(\\log(n))")))), React.createElement(_components.span, {
    className: "katex-html",
    "aria-hidden": "true"
  }, React.createElement(_components.span, {
    className: "base"
  }, React.createElement(_components.span, {
    className: "strut",
    style: {
      height: "1em",
      verticalAlign: "-0.25em"
    }
  }), React.createElement(_components.span, {
    className: "mord mathbb"
  }, "O"), React.createElement(_components.span, {
    className: "mopen"
  }, "("), React.createElement(_components.span, {
    className: "mop"
  }, "lo", React.createElement(_components.span, {
    style: {
      marginRight: "0.01389em"
    }
  }, "g")), React.createElement(_components.span, {
    className: "mopen"
  }, "("), React.createElement(_components.span, {
    className: "mord mathnormal"
  }, "n"), React.createElement(_components.span, {
    className: "mclose"
  }, "))"))))), " lower bound on search. Hash maps have worst case ", React.createElement(_components.span, {
    className: "math math-inline"
  }, React.createElement(_components.span, {
    className: "katex"
  }, React.createElement(_components.span, {
    className: "katex-mathml"
  }, React.createElement(_components.math, {
    xmlns: "http://www.w3.org/1998/Math/MathML"
  }, React.createElement(_components.semantics, null, React.createElement(_components.mrow, null, React.createElement(_components.mi, {
    mathvariant: "double-struck"
  }, "O"), React.createElement(_components.mo, {
    stretchy: "false"
  }, "("), React.createElement(_components.mi, null, "n"), React.createElement(_components.mo, {
    stretchy: "false"
  }, ")")), React.createElement(_components.annotation, {
    encoding: "application/x-tex"
  }, "\\O(n)")))), React.createElement(_components.span, {
    className: "katex-html",
    "aria-hidden": "true"
  }, React.createElement(_components.span, {
    className: "base"
  }, React.createElement(_components.span, {
    className: "strut",
    style: {
      height: "1em",
      verticalAlign: "-0.25em"
    }
  }), React.createElement(_components.span, {
    className: "mord mathbb"
  }, "O"), React.createElement(_components.span, {
    className: "mopen"
  }, "("), React.createElement(_components.span, {
    className: "mord mathnormal"
  }, "n"), React.createElement(_components.span, {
    className: "mclose"
  }, ")"))))), "\nperformance, so trading quick average look-ups for the ", React.createElement(_components.span, {
    className: "math math-inline"
  }, React.createElement(_components.span, {
    className: "katex"
  }, React.createElement(_components.span, {
    className: "katex-mathml"
  }, React.createElement(_components.math, {
    xmlns: "http://www.w3.org/1998/Math/MathML"
  }, React.createElement(_components.semantics, null, React.createElement(_components.mrow, null, React.createElement(_components.mi, {
    mathvariant: "double-struck"
  }, "O"), React.createElement(_components.mo, {
    stretchy: "false"
  }, "("), React.createElement(_components.mi, null, "log"), React.createElement(_components.mo, null, "⁡"), React.createElement(_components.mo, {
    stretchy: "false"
  }, "("), React.createElement(_components.mi, null, "n"), React.createElement(_components.mo, {
    stretchy: "false"
  }, ")"), React.createElement(_components.mo, {
    stretchy: "false"
  }, ")")), React.createElement(_components.annotation, {
    encoding: "application/x-tex"
  }, "\\O(\\log(n))")))), React.createElement(_components.span, {
    className: "katex-html",
    "aria-hidden": "true"
  }, React.createElement(_components.span, {
    className: "base"
  }, React.createElement(_components.span, {
    className: "strut",
    style: {
      height: "1em",
      verticalAlign: "-0.25em"
    }
  }), React.createElement(_components.span, {
    className: "mord mathbb"
  }, "O"), React.createElement(_components.span, {
    className: "mopen"
  }, "("), React.createElement(_components.span, {
    className: "mop"
  }, "lo", React.createElement(_components.span, {
    style: {
      marginRight: "0.01389em"
    }
  }, "g")), React.createElement(_components.span, {
    className: "mopen"
  }, "("), React.createElement(_components.span, {
    className: "mord mathnormal"
  }, "n"), React.createElement(_components.span, {
    className: "mclose"
  }, "))"))))), " bound provided by binary search doesn’t change\nanything. The ability to “do better” given restrictions is a reoccurring theme in CS."), "\n", React.createElement(_components.p, null, "Radix sort works well for values with a limited number of digits—note the ", React.createElement(_components.span, {
    className: "math math-inline"
  }, React.createElement(_components.span, {
    className: "katex"
  }, React.createElement(_components.span, {
    className: "katex-mathml"
  }, React.createElement(_components.math, {
    xmlns: "http://www.w3.org/1998/Math/MathML"
  }, React.createElement(_components.semantics, null, React.createElement(_components.mrow, null, React.createElement(_components.mi, {
    mathvariant: "double-struck"
  }, "O"), React.createElement(_components.mo, {
    stretchy: "false"
  }, "("), React.createElement(_components.mi, null, "k"), React.createElement(_components.mo, null, "⋅"), React.createElement(_components.mi, null, "n"), React.createElement(_components.mo, {
    stretchy: "false"
  }, ")")), React.createElement(_components.annotation, {
    encoding: "application/x-tex"
  }, "\\O(k\\cdot n)")))), React.createElement(_components.span, {
    className: "katex-html",
    "aria-hidden": "true"
  }, React.createElement(_components.span, {
    className: "base"
  }, React.createElement(_components.span, {
    className: "strut",
    style: {
      height: "1em",
      verticalAlign: "-0.25em"
    }
  }), React.createElement(_components.span, {
    className: "mord mathbb"
  }, "O"), React.createElement(_components.span, {
    className: "mopen"
  }, "("), React.createElement(_components.span, {
    className: "mord mathnormal",
    style: {
      marginRight: "0.03148em"
    }
  }, "k"), React.createElement(_components.span, {
    className: "mspace",
    style: {
      marginRight: "0.2222em"
    }
  }), React.createElement(_components.span, {
    className: "mbin"
  }, "⋅"), React.createElement(_components.span, {
    className: "mspace",
    style: {
      marginRight: "0.2222em"
    }
  })), React.createElement(_components.span, {
    className: "base"
  }, React.createElement(_components.span, {
    className: "strut",
    style: {
      height: "1em",
      verticalAlign: "-0.25em"
    }
  }), React.createElement(_components.span, {
    className: "mord mathnormal"
  }, "n"), React.createElement(_components.span, {
    className: "mclose"
  }, ")"))))), " part. The worst case\nperformance for radix is the same as the average case making it pretty deterministic. Also note that we’re not\nrestricted to sorting numbers. ASCII maps English characters to integers in ascending order, so radix sort can be\napplied to text as well. You can probably find a similar mapping for just about any type of input that you would want to\nsort. It’s a great alternative to traditional sort methods for many applications. However, there’s always the break even\npoint where ", React.createElement(_components.span, {
    className: "math math-inline"
  }, React.createElement(_components.span, {
    className: "katex"
  }, React.createElement(_components.span, {
    className: "katex-mathml"
  }, React.createElement(_components.math, {
    xmlns: "http://www.w3.org/1998/Math/MathML"
  }, React.createElement(_components.semantics, null, React.createElement(_components.mrow, null, React.createElement(_components.mi, null, "d"), React.createElement(_components.mo, null, ">"), React.createElement(_components.mi, null, "log"), React.createElement(_components.mo, null, "⁡"), React.createElement(_components.mo, {
    stretchy: "false"
  }, "("), React.createElement(_components.mi, null, "n"), React.createElement(_components.mo, {
    stretchy: "false"
  }, ")")), React.createElement(_components.annotation, {
    encoding: "application/x-tex"
  }, "d > \\log(n)")))), React.createElement(_components.span, {
    className: "katex-html",
    "aria-hidden": "true"
  }, React.createElement(_components.span, {
    className: "base"
  }, React.createElement(_components.span, {
    className: "strut",
    style: {
      height: "0.7335em",
      verticalAlign: "-0.0391em"
    }
  }), React.createElement(_components.span, {
    className: "mord mathnormal"
  }, "d"), React.createElement(_components.span, {
    className: "mspace",
    style: {
      marginRight: "0.2778em"
    }
  }), React.createElement(_components.span, {
    className: "mrel"
  }, ">"), React.createElement(_components.span, {
    className: "mspace",
    style: {
      marginRight: "0.2778em"
    }
  })), React.createElement(_components.span, {
    className: "base"
  }, React.createElement(_components.span, {
    className: "strut",
    style: {
      height: "1em",
      verticalAlign: "-0.25em"
    }
  }), React.createElement(_components.span, {
    className: "mop"
  }, "lo", React.createElement(_components.span, {
    style: {
      marginRight: "0.01389em"
    }
  }, "g")), React.createElement(_components.span, {
    className: "mopen"
  }, "("), React.createElement(_components.span, {
    className: "mord mathnormal"
  }, "n"), React.createElement(_components.span, {
    className: "mclose"
  }, ")"))))), ", after which traditional sort methods have the advantage."), "\n", React.createElement(_components.h2, null, "Interpolation Search"), "\n", React.createElement(_components.p, null, "You really need to understand your data before applying interpolation search since the worst case scenario is ", React.createElement(_components.span, {
    className: "math math-inline"
  }, React.createElement(_components.span, {
    className: "katex"
  }, React.createElement(_components.span, {
    className: "katex-mathml"
  }, React.createElement(_components.math, {
    xmlns: "http://www.w3.org/1998/Math/MathML"
  }, React.createElement(_components.semantics, null, React.createElement(_components.mrow, null, React.createElement(_components.mi, {
    mathvariant: "double-struck"
  }, "O"), React.createElement(_components.mo, {
    stretchy: "false"
  }, "("), React.createElement(_components.mi, null, "n"), React.createElement(_components.mo, {
    stretchy: "false"
  }, ")")), React.createElement(_components.annotation, {
    encoding: "application/x-tex"
  }, "\\O(n)")))), React.createElement(_components.span, {
    className: "katex-html",
    "aria-hidden": "true"
  }, React.createElement(_components.span, {
    className: "base"
  }, React.createElement(_components.span, {
    className: "strut",
    style: {
      height: "1em",
      verticalAlign: "-0.25em"
    }
  }), React.createElement(_components.span, {
    className: "mord mathbb"
  }, "O"), React.createElement(_components.span, {
    className: "mopen"
  }, "("), React.createElement(_components.span, {
    className: "mord mathnormal"
  }, "n"), React.createElement(_components.span, {
    className: "mclose"
  }, ")"))))), "\n(and much worse than that in reality as you’ll end up doing lots of unnecessary branching). However, if you know that\nyour data is reasonably uniform, interpolation search is a great way to go. The intuition is simple. If you have an\nindex that’s uniformly distributed between ", React.createElement(_components.span, {
    className: "math math-inline"
  }, React.createElement(_components.span, {
    className: "katex"
  }, React.createElement(_components.span, {
    className: "katex-mathml"
  }, React.createElement(_components.math, {
    xmlns: "http://www.w3.org/1998/Math/MathML"
  }, React.createElement(_components.semantics, null, React.createElement(_components.mrow, null, React.createElement(_components.mi, null, "a")), React.createElement(_components.annotation, {
    encoding: "application/x-tex"
  }, "a")))), React.createElement(_components.span, {
    className: "katex-html",
    "aria-hidden": "true"
  }, React.createElement(_components.span, {
    className: "base"
  }, React.createElement(_components.span, {
    className: "strut",
    style: {
      height: "0.4306em"
    }
  }), React.createElement(_components.span, {
    className: "mord mathnormal"
  }, "a"))))), " and ", React.createElement(_components.span, {
    className: "math math-inline"
  }, React.createElement(_components.span, {
    className: "katex"
  }, React.createElement(_components.span, {
    className: "katex-mathml"
  }, React.createElement(_components.math, {
    xmlns: "http://www.w3.org/1998/Math/MathML"
  }, React.createElement(_components.semantics, null, React.createElement(_components.mrow, null, React.createElement(_components.mi, null, "b")), React.createElement(_components.annotation, {
    encoding: "application/x-tex"
  }, "b")))), React.createElement(_components.span, {
    className: "katex-html",
    "aria-hidden": "true"
  }, React.createElement(_components.span, {
    className: "base"
  }, React.createElement(_components.span, {
    className: "strut",
    style: {
      height: "0.6944em"
    }
  }), React.createElement(_components.span, {
    className: "mord mathnormal"
  }, "b"))))), " and you’re looking for a value ", React.createElement(_components.span, {
    className: "math math-inline"
  }, React.createElement(_components.span, {
    className: "katex"
  }, React.createElement(_components.span, {
    className: "katex-mathml"
  }, React.createElement(_components.math, {
    xmlns: "http://www.w3.org/1998/Math/MathML"
  }, React.createElement(_components.semantics, null, React.createElement(_components.mrow, null, React.createElement(_components.mi, null, "x")), React.createElement(_components.annotation, {
    encoding: "application/x-tex"
  }, "x")))), React.createElement(_components.span, {
    className: "katex-html",
    "aria-hidden": "true"
  }, React.createElement(_components.span, {
    className: "base"
  }, React.createElement(_components.span, {
    className: "strut",
    style: {
      height: "0.4306em"
    }
  }), React.createElement(_components.span, {
    className: "mord mathnormal"
  }, "x"))))), ", a good place to start is an\ninterpolation: ", React.createElement(_components.span, {
    className: "math math-inline"
  }, React.createElement(_components.span, {
    className: "katex"
  }, React.createElement(_components.span, {
    className: "katex-mathml"
  }, React.createElement(_components.math, {
    xmlns: "http://www.w3.org/1998/Math/MathML"
  }, React.createElement(_components.semantics, null, React.createElement(_components.mrow, null, React.createElement(_components.mi, null, "a"), React.createElement(_components.mo, null, "+"), React.createElement(_components.mi, null, "x"), React.createElement(_components.mfrac, null, React.createElement(_components.mrow, null, React.createElement(_components.mi, null, "x"), React.createElement(_components.mo, null, "−"), React.createElement(_components.mi, null, "a")), React.createElement(_components.mrow, null, React.createElement(_components.mi, null, "b"), React.createElement(_components.mo, null, "−"), React.createElement(_components.mi, null, "a")))), React.createElement(_components.annotation, {
    encoding: "application/x-tex"
  }, "a + x \\frac{x - a}{b - a}")))), React.createElement(_components.span, {
    className: "katex-html",
    "aria-hidden": "true"
  }, React.createElement(_components.span, {
    className: "base"
  }, React.createElement(_components.span, {
    className: "strut",
    style: {
      height: "0.6667em",
      verticalAlign: "-0.0833em"
    }
  }), React.createElement(_components.span, {
    className: "mord mathnormal"
  }, "a"), React.createElement(_components.span, {
    className: "mspace",
    style: {
      marginRight: "0.2222em"
    }
  }), React.createElement(_components.span, {
    className: "mbin"
  }, "+"), React.createElement(_components.span, {
    className: "mspace",
    style: {
      marginRight: "0.2222em"
    }
  })), React.createElement(_components.span, {
    className: "base"
  }, React.createElement(_components.span, {
    className: "strut",
    style: {
      height: "1.2057em",
      verticalAlign: "-0.4033em"
    }
  }), React.createElement(_components.span, {
    className: "mord mathnormal"
  }, "x"), React.createElement(_components.span, {
    className: "mord"
  }, React.createElement(_components.span, {
    className: "mopen nulldelimiter"
  }), React.createElement(_components.span, {
    className: "mfrac"
  }, React.createElement(_components.span, {
    className: "vlist-t vlist-t2"
  }, React.createElement(_components.span, {
    className: "vlist-r"
  }, React.createElement(_components.span, {
    className: "vlist",
    style: {
      height: "0.8023em"
    }
  }, React.createElement(_components.span, {
    style: {
      top: "-2.655em"
    }
  }, React.createElement(_components.span, {
    className: "pstrut",
    style: {
      height: "3em"
    }
  }), React.createElement(_components.span, {
    className: "sizing reset-size6 size3 mtight"
  }, React.createElement(_components.span, {
    className: "mord mtight"
  }, React.createElement(_components.span, {
    className: "mord mathnormal mtight"
  }, "b"), React.createElement(_components.span, {
    className: "mbin mtight"
  }, "−"), React.createElement(_components.span, {
    className: "mord mathnormal mtight"
  }, "a")))), React.createElement(_components.span, {
    style: {
      top: "-3.23em"
    }
  }, React.createElement(_components.span, {
    className: "pstrut",
    style: {
      height: "3em"
    }
  }), React.createElement(_components.span, {
    className: "frac-line",
    style: {
      borderBottomWidth: "0.04em"
    }
  })), React.createElement(_components.span, {
    style: {
      top: "-3.394em"
    }
  }, React.createElement(_components.span, {
    className: "pstrut",
    style: {
      height: "3em"
    }
  }), React.createElement(_components.span, {
    className: "sizing reset-size6 size3 mtight"
  }, React.createElement(_components.span, {
    className: "mord mtight"
  }, React.createElement(_components.span, {
    className: "mord mathnormal mtight"
  }, "x"), React.createElement(_components.span, {
    className: "mbin mtight"
  }, "−"), React.createElement(_components.span, {
    className: "mord mathnormal mtight"
  }, "a"))))), React.createElement(_components.span, {
    className: "vlist-s"
  }, "​")), React.createElement(_components.span, {
    className: "vlist-r"
  }, React.createElement(_components.span, {
    className: "vlist",
    style: {
      height: "0.4033em"
    }
  }, React.createElement(_components.span))))), React.createElement(_components.span, {
    className: "mclose nulldelimiter"
  })))))), ". Interpolation search does this repeatedly, subdividing intervals and\ninterpolating again. We can apply the same principals to an arbitrary distribution; the uniform distribution was chosen\nas it leads to a simple, canonical implementation with provable bounds. Here’s a derivation of the\n", React.createElement(_components.a, {
    href: "https://www.cs.technion.ac.il/~itai/publications/Algorithms/p550-perl.pdf"
  }, "time complexity for interpolation search"), "."));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
